import { initUseForm } from "../../../utils/form";
import { createLoading } from "../../../utils/loading";
import router from "../../../router";

export const { isLoading, setIsLoading } = createLoading();

export const loadForm = ({ props, data, refs }) => {
    setIsLoading(true);
    const { useForm } = data;
    const { modelRef } = useForm;
    let promise = Promise.resolve({ data: [modelRef] });
    return promise
        .then(page => initUseForm({ props, data, refs, page }))
        .then(() => initUseForm({ props, data, refs, page: { data: [modelRef] } }))
        .finally(() => setIsLoading(false));
};

export const onClickBack = ({ key }) => {
    const registerType = key
    router.push({ name: `register-${registerType}` });
}

